import BaseProcessor from './BaseProcessor';
import store from '@/store';
import PaymentTypes from '@/models/PaymentTypes';

export default class AleloVoucherProcessor extends BaseProcessor {
    constructor(multiLanguage) {
        super(multiLanguage);
    }

    /**
     * Processa a transação de vouchers alelo
     */
    async ProcessTransaction() {
        super.BuildContract({
            ...store.getters['cardPayment/getSubmitModel'],
            PaymentType: PaymentTypes.DEBIT_CARD
        });

        let response = await super.SendTransactionRequest();
        
        if (super.ResponseIsSuccess(response) == false) return;
        
        store.dispatch('preorder/setTransactionAsFinalized');

        // Redireciona para a url do merchant caso solicitado
        if (response.Data.Redirect && response.Data.Url)
            return window.location.href = response.Data.Url;
        
        store.dispatch('pipelineV2/pushToOrderStatus', response.Data.OrderId);
    }
}
